<template>
    <div class="c-advanced-search__bg"
        @click.prevent="toggleAdvancedSearch()"
    ></div>
    <div class="c-advanced-search__inner" data-lenis-prevent>
        <button class="c-advanced-search__close js-advanced-search__focus"
            @click.prevent="toggleAdvancedSearch()"
            aria-label="Ouvrir et/ou fermer la recherche"
        >
            <span></span>
            <span></span>
        </button>
        <div class="c-advanced-search__content">
            <div class="o-form">
                <div class="o-form__item">
                    <label class="o-label sr-only" for="programmes-search">Mots clés</label>
                    <input @keyup="keyupSearch()" class="o-input" id="programmes-search" type="text" placeholder="Mots clés" v-model="searchInput">
                    <svg class="o-ico -ico-search" role="img">
                        <title>search</title>
                        <use xlink:href="/assets/img/sprite.svg?v=2#search"></use>
                    </svg>
                </div>
                <div class="o-spacer -spacer-xs"></div>
                <div class="c-advanced-search__row">
                    <div class="c-advanced-search__item">
                        <div v-if="years.length>0" id="title-1" class="c-advanced-search__mobile-accordion">
                            <div class="c-advanced-search__item__title">
                                <div class="o-title-5">
                                    Année
                                </div>
                                <button class="c-advanced-search__accordion__toggler" data-module="ClassToggle" data-target="#title-1" data-class="is-open">
                                    <svg class="o-ico -ico-arrow-down" role="img">
                                        <title>arrow-down</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                    </svg>
                                </button>
                            </div>
                            <div class="c-advanced-search__item__filters">
                                <div class="c-advanced-search__item__filters__inner">
                                    <div v-for="year in years" class="o-checkbox__wrap">
                                        <input @change="updateAttributes()" :id="'year'+year" class="o-checkbox" type="checkbox" v-model="selectedYears" :value="year">
                                        <label class="o-checkbox-label" :for="'year'+year">
                                            {{ year }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="formats.length>0" id="title-2" class="c-advanced-search__mobile-accordion">
                            <div class="c-advanced-search__item__title">
                                <div class="o-title-5">
                                    Formats
                                </div>
                                <button class="c-advanced-search__accordion__toggler" data-module="ClassToggle" data-target="#title-2" data-class="is-open">
                                    <svg class="o-ico -ico-arrow-down" role="img">
                                        <title>arrow-down</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                    </svg>
                                </button>
                            </div>
                            <div class="c-advanced-search__item__filters">
                                <div class="c-advanced-search__item__filters__inner">
                                    <div v-for="format in formats" class="o-checkbox__wrap">
                                        <input @change="updateAttributes()" :id="'format'+format.id" class="o-checkbox" type="checkbox" v-model="selectedFormats" :value="format.id">
                                        <label class="o-checkbox-label" :for="'format'+format.id">
                                            {{ format.title }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="jesuis.length>0" class="c-advanced-search__item">
                        <div id="title-3" class="c-advanced-search__mobile-accordion">
                            <div class="c-advanced-search__item__title">
                                <div class="o-title-5">
                                    Je suis
                                </div>
                                <button class="c-advanced-search__accordion__toggler" data-module="ClassToggle" data-target="#title-3" data-class="is-open">
                                    <svg class="o-ico -ico-arrow-down" role="img">
                                        <title>arrow-down</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                    </svg>
                                </button>
                            </div>
                            <div class="c-advanced-search__item__filters">
                                <div class="c-advanced-search__item__filters__inner">
                                    <div v-for="je in jesuis" class="o-checkbox__wrap">
                                        <input @change="updateAttributes()" :id="'jesuis'+je.id" class="o-checkbox" type="checkbox" v-model="selectedJesuis" :value="je.id">
                                        <label class="o-checkbox-label" :for="'jesuis'+je.id">
                                            {{ je.title }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="categories.length>0" class="c-advanced-search__item" :class="{'is-open': thematique}">
                        <div id="title-4" class="c-advanced-search__mobile-accordion">
                            <div class="c-advanced-search__item__title">
                                <div class="o-title-5">
                                    Thématiques
                                </div>
                                <button class="c-advanced-search__accordion__toggler" @click.prevent="thematique=!thematique">
                                    <svg class="o-ico -ico-arrow-down" role="img">
                                        <title>arrow-down</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                    </svg>
                                </button>
                            </div>
                            <div class="c-advanced-search__item__filters">
                                <div class="c-advanced-search__item__filters__inner">
                                    <template v-for="category in categories">
                                        <div v-if="category.parent===null" class="c-advanced-search__accordion">
                                            <div class="c-advanced-search__accordion__item" :class="{'is-open': accordions.includes(category.id)}">
                                                <div  class="c-advanced-search__accordion__head">
                                                    <div class="o-checkbox__wrap">
                                                        <input @change="updateAttributes()" class="o-checkbox" type="checkbox" :id="'cat'+category.id" v-model="selectedCategories" :value="category.id">
                                                        <label class="o-checkbox-label" :for="'cat'+category.id">
                                                            {{ category.title }}
                                                        </label>
                                                    </div>
                                                    <button v-if="hasChilds(category)" class="c-advanced-search__accordion__toggler" @click.prevent="toggleAccordion(category)">
                                                        <svg class="o-ico -ico-arrow-down" role="img">
                                                            <title>arrow-down</title>
                                                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div v-if="hasChilds(category)" class="c-advanced-search__accordion__content">
                                                    <div class="c-advanced-search__accordion__content__inner">
                                                        <template v-for="child in categories">
                                                            <div v-if="child.parent===category.id && !hasChilds(child)" class="o-checkbox__wrap">
                                                                <input @change="updateAttributes()" class="o-checkbox" type="checkbox" :id="'cat'+child.id" v-model="selectedCategories" :value="child.id">
                                                                <label class="o-checkbox-label" :for="'cat'+child.id">
                                                                    {{ child.title }}
                                                                </label>
                                                            </div>
                                                            <div v-else-if="child.parent===category.id && hasChilds(child)" class="c-advanced-search__accordion__item" :class="{'is-open': accordions.includes(child.id)}">
                                                                <div class="c-advanced-search__accordion__head">
                                                                    <div class="o-checkbox__wrap">
                                                                        <input @change="updateAttributes()" class="o-checkbox" type="checkbox" :id="'cat'+child.id" v-model="selectedCategories" :value="child.id">
                                                                        <label class="o-checkbox-label" :for="'cat'+child.id">
                                                                            {{ child.title }}
                                                                        </label>
                                                                    </div>
                                                                    <button class="c-advanced-search__accordion__toggler"  @click.prevent="toggleAccordion(child)">
                                                                        <svg class="o-ico -ico-arrow-down" role="img">
                                                                            <title>arrow-down</title>
                                                                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                                                                        </svg>
                                                                    </button>
                                                                </div>
                                                                <div class="c-advanced-search__accordion__content">
                                                                    <div class="c-advanced-search__accordion__content__inner">
                                                                        <template v-for="subchild in categories">
                                                                            <div v-if="subchild.parent==child.id" class="o-checkbox__wrap">
                                                                                <input @change="updateAttributes()" class="o-checkbox" type="checkbox" :id="'cat'+subchild.id" v-model="selectedCategories" :value="subchild.id">
                                                                                <label class="o-checkbox-label" :for="'cat'+subchild.id">
                                                                                    {{ subchild.title }}
                                                                                </label>
                                                                            </div>
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="o-spacer -spacer-xs"></div>
                <div class="c-advanced-search__buttons">
                    <div class="c-programmes-search__filters__reset">
                        <button class="o-button -button-reset" @click.prevent="reset()">
                            Réinitialiser la recherche
                        </button>
                    </div>
                    <div class="c-programmes-search__filters__apply">
                        <button @click.prevent="toggleAdvancedSearch()" class="o-button -button-apply-filters">
                            Consulter les {{ results }} résultats
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';

    export default {
        name: 'BlogAdvancedSearch',
        data() {
            return {
                searchInput: '',
                isOpen: false,
                years: [],
                jesuis: [],
                formats: [],
                categories: [],
                selectedYears: [],
                selectedJesuis: [],
                selectedFormats: [],
                selectedCategories: [],
                accordions: [],
                thematique: false,
                results: 0
            }
        },
        mounted() {
            this.emitter.on('toggleAdvancedSearch', this.toggleAdvancedSearch)
            this.emitter.on('fetchBlogAttributes', this.fetchAttributes)
            this.emitter.on('selectedAttributes', this.selectedAttributes)
            this.emitter.emit('requestSelectedAttributes')
        },
        methods: {
            toggleAdvancedSearch() {
                //console.log('TOGGLE')
                this.isOpen = !this.isOpen
                const html = document.querySelector('html')
                html.classList.toggle('has-advanced-search-open', this.isOpen)
                html.classList.remove('has-nav-open')
            },
            fetchAttributes(data) {
                //console.log('FETCH')
                if (data.years !== undefined) this.years = data.years;
                if (data.categories !== undefined) this.categories = data.categories;
                if (data.jesuis !== undefined) this.jesuis = data.jesuis;
                if (data.formats !== undefined) this.formats = data.formats;
            },
            selectedAttributes(data) {
                if (data.years !== undefined) this.selectedYears = data.years;
                if (data.categories !== undefined) this.selectedCategories = data.categories;
                if (data.jesuis !== undefined) this.selectedJesuis = data.jesuis;
                if (data.formats !== undefined) this.selectedFormats = data.formats;
                if (data.searchInput !== undefined) this.searchInput = data.searchInput;
                if (data.results !== undefined) this.results = data.results;
            },
            hasChilds(category) {
                let hasChild = false
                this.categories.forEach(cat => {
                    if (cat.parent === category.id) {
                        hasChild = true
                    }
                })
                return hasChild
            },
            toggleAccordion(category) {
                if (this.accordions.includes(category.id)) {
                    this.accordions = this.accordions.filter(acc => acc !== category.id)
                } else {
                    this.accordions.push(category.id)
                }
            }
            ,
            updateAttributes() {
                this.emitter.emit('updateSelectedAttributes', {
                    years: this.selectedYears,
                    categories: this.selectedCategories,
                    jesuis: this.selectedJesuis,
                    formats: this.selectedFormats,
                    searchInput: this.searchInput
                })
            },
            keyupSearch() {
                this.debounceUpdate()
            },
            debounceUpdate: debounce(function(e) {
                this.updateAttributes()
            }, 500),
            reset() {
                this.toggleAdvancedSearch()
                this.emitter.emit('emitReset')
                this.isOpen = false
            }
        }
    }
</script>